/**
 * This Mapping describe the two-way relation of TextInput color theme <-> airwallex global colors, in order to:
 * 1. building TextInput color theme
 * 2. providing convenience for color configuration tool
 * (It's important to know which color from awx global is linked to the specific color in Button theme)
 */
export var textInputColorThemeSchema = {
  primary: {
    border: {
      initial: 'inputBorder',
      focus: 'ultraViolets.70'
    },
    text: {
      initial: 'darkGrey'
    },
    placeholder: {
      initial: 'grey'
    },
    background: {
      initial: 'inputBackground',
      hover: 'white'
    }
  },
  error: {
    border: {
      initial: 'reds.50',
      focus: 'reds.50'
    }
  },
  disabled: {
    background: {
      hover: 'bgGrey'
    },
    text: {
      initial: 'grey'
    }
  }
};